import { IUuidsToPaymentRefsResults } from '@schemas/opsPortal/types/uuidsToPaymentRefs';
import { missingValuePlaceholder } from '@utils/constants';

interface IWithContractUuid {
  contract_uuid: string;
}

interface IResults<T> {
  results: T[];
}

export const enrichWithPaymentRefsAndExternalUuids = <
  T extends IWithContractUuid,
  P extends IResults<T>,
>(
  data: P,
  uuidPaymentRefs: IUuidsToPaymentRefsResults,
): P & {
  results: (T & { external_uuid?: string; payment_plan_ref: string })[];
} => {
  const mappedData = data?.results?.map(item => {
    const matchedUuidPaymentRef = uuidPaymentRefs.find(
      ref => ref.contract_uuid === item.contract_uuid,
    );

    return {
      ...item,
      external_uuid: matchedUuidPaymentRef?.external_uuid,
      payment_plan_ref:
        matchedUuidPaymentRef?.payment_plan_reference ??
        missingValuePlaceholder,
    };
  });

  return {
    ...data,
    results: mappedData,
  };
};
